import React, { ChangeEvent } from 'react';

import ButtonComponent from '../ButtonComponent/ButtonComponent';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from './ModalComponent';

interface WarningModalProps {
  icon?: string | React.ReactNode;
  title: string;
  description?: string | React.ReactNode;
  show: boolean;
  onClose: () => void;
  disableSubmitButton?: boolean;
  actionFunction: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  width?: string | number;
  actionButtonText: string | React.ReactNode;
  actionButtonType?: string;
  cancelButtonText?: string;
  showLoading?: boolean;
  buttonDirection?: string;
  iconBgColor?: string;
  children?: React.ReactNode;
  footer?: string | React.ReactNode;
  outsideClickClose?: boolean;
  disableSubmitButtonTooltipText?: string;
}

export default function WarningModal({
  icon = '⚠️',
  title,
  description = '',
  show,
  onClose,
  disableSubmitButton = false,
  actionFunction,
  width = 360,
  actionButtonText,
  actionButtonType = 'primary',
  cancelButtonText = 'Cancel',
  showLoading = false,
  buttonDirection = 'horizontal',
  iconBgColor,
  children,
  footer,
  outsideClickClose = true,
  disableSubmitButtonTooltipText = 'Please fill in all fields',
}: WarningModalProps) {
  return (
    <ModalComponent show={show} onClose={onClose} width={width} outsideClickClose={outsideClickClose}>
      <div className="error-modal modal-main-content">
        <IconContainer icon={icon} bgColor={iconBgColor} />
        <h2 style={{ padding: '0 8px' }}>{title}</h2>
        {description && <p className="enter-list-name">{description}</p>}
        {children}
        <div
          className="modal-footer-button-container"
          style={{
            flexDirection: buttonDirection === 'horizontal' ? 'row' : 'column-reverse',
            alignItems: 'stretch',
          }}>
          <ButtonComponent style={{ flex: 1 }} onClick={onClose} variant="secondary">
            {cancelButtonText}
          </ButtonComponent>
          <CustomTooltip
            title={disableSubmitButtonTooltipText}
            show={disableSubmitButton && Boolean(disableSubmitButtonTooltipText)}>
            <ButtonComponent
              style={{ flex: 1 }}
              type="submit"
              onClick={(e) => {
                if (showLoading) return;
                actionFunction(e);
              }}
              disabled={disableSubmitButton}
              variant={actionButtonType}
              showLoading={showLoading}>
              <span className="text-base">{actionButtonText}</span>
            </ButtonComponent>
          </CustomTooltip>
        </div>
        {footer && <div>{footer}</div>}
      </div>
    </ModalComponent>
  );
}
